import {
  Home, Building2, Car, Package,
  Bed, Sofa, Utensils, Refrigerator, Tv, WashingMachine, Wind, Microwave,
  Armchair, Table2, Monitor, Printer, Server, Files, HardDrive, Fan,
} from "lucide-react";

export const SHIFTING_TYPES = [
  { id: "home", title: "Home Shifting", desc: "Villas, apartments, family homes", Icon: Home },
  { id: "office", title: "Office Shifting", desc: "Offices, coworking, corporate", Icon: Building2 },
  { id: "vehicle", title: "Vehicle Transport", desc: "Car, bike, scooter transport", Icon: Car },
  { id: "other", title: "Other / General", desc: "Anything else — tell us more", Icon: Package },
];

export const ITEM_CATALOG = {
  home: [
    {
      label: "Furniture",
      items: [
        { name: "Double Bed", Icon: Bed },
        { name: "Single Bed", Icon: Bed },
        { name: "Sofa (3-seater)", Icon: Sofa },
        { name: "Sofa (2-seater)", Icon: Sofa },
        { name: "Dining Table", Icon: Table2 },
        { name: "Wardrobe", Icon: Armchair },
        { name: "Study Table", Icon: Table2 },
        { name: "Chair", Icon: Armchair },
        { name: "Shoe Rack", Icon: Armchair },
      ],
    },
    {
      label: "Appliances",
      items: [
        { name: "Refrigerator", Icon: Refrigerator },
        { name: "Washing Machine", Icon: WashingMachine },
        { name: "Air Conditioner", Icon: Wind },
        { name: "Television", Icon: Tv },
        { name: "Microwave", Icon: Microwave },
        { name: "Ceiling Fan", Icon: Fan },
        { name: "Water Purifier", Icon: HardDrive },
      ],
    },
    {
      label: "Kitchen & Boxes",
      items: [
        { name: "Utensil Boxes", Icon: Utensils },
        { name: "Small Cartons", Icon: Package },
        { name: "Medium Cartons", Icon: Package },
        { name: "Large Cartons", Icon: Package },
        { name: "Gas Cylinder", Icon: HardDrive },
      ],
    },
  ],
  office: [
    {
      label: "Office Furniture",
      items: [
        { name: "Office Desk", Icon: Table2 },
        { name: "Office Chair", Icon: Armchair },
        { name: "Conference Table", Icon: Table2 },
        { name: "Filing Cabinet", Icon: Armchair },
        { name: "Workstation", Icon: Table2 },
      ],
    },
    {
      label: "Electronics",
      items: [
        { name: "Desktop Computer", Icon: Monitor },
        { name: "Monitor", Icon: Monitor },
        { name: "Printer", Icon: Printer },
        { name: "Server / NAS", Icon: Server },
        { name: "Air Conditioner", Icon: Wind },
      ],
    },
    {
      label: "Files & Boxes",
      items: [
        { name: "Document Box", Icon: Files },
        { name: "Small Cartons", Icon: Package },
        { name: "Medium Cartons", Icon: Package },
        { name: "Large Cartons", Icon: Package },
      ],
    },
  ],
  vehicle: [
    {
      label: "Vehicle Type",
      items: [
        { name: "Car (Sedan)", Icon: Car },
        { name: "Car (SUV)", Icon: Car },
        { name: "Bike", Icon: Car },
        { name: "Scooter", Icon: Car },
      ],
    },
  ],
  other: [],
};

export const TIME_SLOTS = [
  "Early Morning (6am-9am)",
  "Morning (9am-12pm)",
  "Afternoon (12pm-3pm)",
  "Evening (3pm-6pm)",
  "Late Evening (6pm-9pm)",
  "Flexible",
];

export const VEHICLE_TYPES = [
  "Auto-suggest based on items",
  "Tata Ace / Mini",
  "Pickup / Tempo (Chotta Hathi)",
  "14ft Truck",
  "17ft Truck",
  "20ft Truck",
  "Container Truck",
];

export function suggestVehicle(items) {
  const total = items.reduce((sum, i) => sum + (i.quantity || 0), 0);
  if (total === 0) return "Auto-suggest based on items";
  if (total <= 8) return "Tata Ace / Mini";
  if (total <= 20) return "Pickup / Tempo (Chotta Hathi)";
  if (total <= 40) return "14ft Truck";
  if (total <= 70) return "17ft Truck";
  return "20ft Truck";
}
